import { Injectable, NgZone } from '@angular/core';

type BeaconFn = (method: string, options?: unknown, data?: unknown) => void;

@Injectable({
  providedIn: 'root'
})
export class BeaconService {
  // Style applied on pages that should show the floating launcher.
  // Switch to 'icon' if the HelpScout dashboard default is icon-only.
  private static readonly VISIBLE_STYLE = 'iconAndText';
  private static readonly HIDDEN_STYLE = 'manual';

  constructor(private readonly _zone: NgZone) {}

  private get beacon(): BeaconFn | undefined {
    const candidate = (window as any).Beacon;
    return typeof candidate === 'function' ? (candidate as BeaconFn) : undefined;
  }

  // HelpScout's widget schedules timers/microtasks on every call; running it
  // inside the Angular zone triggers change detection continuously while the
  // panel is open and freezes heavy pages, so escape the zone first.
  public setLauncherVisible(visible: boolean): void {
    const beacon = this.beacon;
    if (!beacon) {
      return;
    }

    const style = visible
      ? BeaconService.VISIBLE_STYLE
      : BeaconService.HIDDEN_STYLE;
    this._zone.runOutsideAngular(() =>
      beacon('config', { display: { style } })
    );
  }

  public open(): void {
    const beacon = this.beacon;
    if (!beacon) {
      return;
    }

    this._zone.runOutsideAngular(() => beacon('open'));
  }

  // Beacon only ever loads once functional consent is granted (and in
  // production); callers use this to detect the no-op case and offer an
  // alternative rather than silently doing nothing.
  public isAvailable(): boolean {
    return !!this.beacon;
  }
}
